import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication.service';
import { MessageService } from 'primeng/api';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(
        private authenticationService: AuthenticationService,
        private messageService: MessageService
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401 && request.url.includes('login') ) {
                this.messageService.add({severity:'error', summary:'Error', detail:'Credenciales no coinciden'});
            } else if (err.status === 401 ) {
                this.messageService.add({severity:'error', summary:'Error', detail:'Sesión vencida'});
                this.authenticationService.logout();
            } if (err.status === 404) {
                this.messageService.add({severity:'error', summary:'Error', detail: err.error.message});
            }

            const error = err.error.message || err.statusText;
            console.log(error)
            return throwError(() => new Error(error));
        }))
    }
}